(function(PromoBar, $){
  'use strict';

  var $promoBar,
      $promoMobileSlider;

  function _cacheDom() {
    $promoBar = $('.promo-bar');
    $promoMobileSlider = $promoBar.find('.slider.mobile');
  }

  function _bindUIActions() {
    $promoMobileSlider.on('initialized.owl.carousel', function() {
      $promoBar.css('opacity', 1);
    });

  }

  function init() {
    _cacheDom();
    _bindUIActions();
  }

  PromoBar.init = init;
})(window.PromoBar = window.PromoBar || {}, jQuery);
